import { makeStyles } from '@eagleview/ev-comp-library';
import Image from 'assets/Cover.svg';

const useStyles = makeStyles((theme) => ({
  box: {
    width: '100%',
    height: `calc(100vh - ${theme.spacing(6)}px)`,
    marginTop: theme.spacing(0.5),
    backgroundImage: `url(${Image})`,
    backgroundSize: 'cover',
    backgroundRepeat: 'no-repeat',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  card: {
    padding: theme.spacing(4),
    height: theme.spacing(68),
    width: theme.spacing(56.25),
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  appPaper: {
    minHeight: theme.spacing(12.5),
    padding: theme.spacing(2.5),
    textAlign: 'center',
    margin: `${theme.spacing(2.5)}px ${theme.spacing(0.25)}px`,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    overflowWrap: 'break-word',
  },
  linkStyle: {
    textDecoration: 'none',
    '&:hover': {
      cursor: 'pointer',
    },
  },
  appTypo: {
    fontSize: theme.spacing(2.5),
    color: theme.evPalette.charcoal[700],
    fontWeight: 400,
    fontFamily: '"Helvetica Neue"',
  },
  appUrlTypo: {
    fontSize: theme.spacing(3),
    fontFamily: '"Helvetica Neue"',
  },
  appBox: {
    width: '100%',
    overflowY: 'scroll',
  },
  circularProgressBar: {
    color: theme.evPalette.charcoal[300],
  },
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
  },
  userNotEntitledBox: {
    textAlign: 'center',
    marginTop: theme.spacing(25),
  },
  userNotEntitledHeading: {
    fontWeight: 400,
    lineHeight: '36px',
  },
  userNotEntitledText: {
    fontSize: theme.spacing(3.25),
    lineHeight: '36px',
    color: theme.evPalette.charcoal[600],
  },
  manageAppsIcon: { fontSize: theme.spacing(17.375), marginBottom: theme.spacing(2) },
  portalBox: { width: theme.spacing(33.75) },
  portalHeader: {
    marginBottom: theme.spacing(1),
    textAlign: 'center',
    fontSize: theme.spacing(2.5),
    fontWeight: 550,
    lineHeight: '36px',
    fontFamily: '"Helvetica Neue"',
  },
}));

export default useStyles;
